/**
 * @generated SignedSource<<e7cf7d34f32c08516494c4612d6972c2>>
 * @relayHash f6540ce76e12493d1a53a97408a3dc08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f972d9490d605c885830ce0ef88f437ef4c1b1680726fbc2fbc828bbba56baa

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareTimelineAppQuery } from './JiraSoftwareTimelineAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareTimelineAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8f972d9490d605c885830ce0ef88f437ef4c1b1680726fbc2fbc828bbba56baa",
    "metadata": {},
    "name": "JiraSoftwareTimelineAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
